<!-- 提示框 -->
<template>
  <div>
      <section v-if="show" class="modal-wrap">
      <div class="modal-content">
        <div class="modal">
          <h3>信息正在审核中</h3>
          <div>
            <!-- <span @click="cancel" class="cancel">取消</span> -->
            <span @click="confirm" class="confirm">确定</span>
          </div>   
        </div> 
      </div>
      <div class="bg"></div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    show: {
      get: function() {
        return this.showModal;
      },
      set: function() {}
    }
  },
  props: ["showModal"],
  methods: {
    // cancel: function() {
    //   console.log("取消");
    //   this.show = false;
    // },
    confirm: function() {
      console.log("确定");
      this.show = false;
      this.$router.push({ path: "/" });
    }
  }
};
</script>
<style  scoped>
.modal-wrap {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.modal-wrap .modal-content {
  width: 500px;
  height: 200px;
  border-radius: 10px;
  background: #fff;
  z-index: 1000;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.modal-wrap .modal-content .modal {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}
.modal-wrap .modal-content .modal span {
  display: inline-block;
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin: 0 50px;
}
.modal-wrap .modal-content .modal .cancel {
  background: #edebeb;
}
.modal-wrap .modal-content .modal .confirm {
  background: #00a0e9;
  color: #fff;
}
.modal-wrap .bg {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: #333;
  opacity: 0.7;
  z-index: 100;
}
</style>


// WEBPACK FOOTER //
// src/components/Modal.vue